import { Button, Modal } from "react-bootstrap";

const ImagePreviewModal = ({ show, handleClose, imageUrl, imageAlt }) => {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      dialogClassName="modal-dialog-centered"
      contentClassName="custom-modal-new-provider"
      size="md"
    >
      <Modal.Header
        style={{ borderBottom: "0px" }}
        className="text-center height-25 p-0 bg-primary popup-heading-color justify-content-center"
      >
        <Modal.Title
          className="mx-auto height-25 font-weight-semibold text-uppercase popup-heading-color d-flex align-items-center"
          style={{ fontSize: "14px", fontWeight: "600" }}
        >
          Image Preview
        </Modal.Title>
      </Modal.Header>

      <Modal.Body
        className=""
        style={{
          padding: "5px",
        }}
      >
        <img
          src={imageUrl}
          alt={imageAlt}
          style={{ width: "100%", height: "auto", maxHeight: "80vh", objectFit: "contain" }}
        />
      </Modal.Body>

      <Modal.Footer
        className="p-0 mt-0 padding-outside-btn-new-provider"
        style={{ borderTop: "none" }}
      >
        <div />
        <Button
          className="button-padding-footer-new-provider d-flex align-items-center justify-content-center"
          variant="secondary"
          onClick={handleClose}
        >
          Close
        </Button>
        <div />
      </Modal.Footer>
    </Modal>
  );
};

export default ImagePreviewModal;
